// extracted by css-extract-rspack-plugin
export default {"trigger":"cDEQUaSK_pQz2rVL"};